import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../utils/apiClient';

export const fetchTheme = createAsyncThunk(
  'theme/fetchTheme',
  async () => {
    // const response = await apiClient.get('/theme');
    // return response.data;
  }
);

export const saveTheme = createAsyncThunk(
  'theme/saveTheme',
  async (newTheme) => {
    console.log('Saving Theme to API:', newTheme);
    // await apiClient.put('/theme', newTheme);
    return newTheme;
  }
);

const defaultTheme = {
  'color-primary': 'rgb(75, 108, 135)',
  'color-secondary': 'rgb(188, 126, 48)',
  'color-bg': 'rgb(244, 243, 248)',  
  'color-sidebar-bg': 'white',      
  'color-text': '#ffffff',
  'color-landing-left': '#fff',
  'color-landing-right': 'linear-gradient(174deg, #BC7E30 4%, #ECBE84 52.8%)'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    values: defaultTheme,
    imageFileName: 'ebrSidebar.jpg',
    status: 'idle'
  },
  reducers: {
    updateThemeLocal(state, action) {
      console.log('Local Theme Updated in Redux:', action.payload);
      state.values = { ...state.values, ...action.payload };
    },
    updateImageFileName(state, action) {
      console.log('Image Filename Updated in Redux:', action.payload);
      state.imageFileName = action.payload;
      localStorage.setItem('imageFileName', action.payload);
    },
    resetTheme(state) {
      console.log('Resetting Theme to Default');
      state.values = defaultTheme;
      state.imageFileName = 'ebrSidebar.jpg';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTheme.fulfilled, (state, action) => {
        state.values = { ...state.values, ...action.payload };
      })
      .addCase(saveTheme.fulfilled, (state, action) => {
        state.values = { ...state.values, ...action.payload };
      });
  }
});

export const { updateThemeLocal, updateImageFileName, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
